import findByMatchingProperties from 'utils/find-matching-properties';

export default function passesMultiCheckboxFilter(item, filter) {
    // IF the active filter does not have values then we pass the check without question
    if (!filter.values.length) { return true; }

    // Find the filter option on the item that matches the active filter
    const matchedItemFilterOptions = findByMatchingProperties(item, { code: filter.code });
    // if we did not find a match, then this item does not pass the filtering
    if (!matchedItemFilterOptions || !matchedItemFilterOptions.length) { return false; }

    // then check if all matched filter options have a match between their values array and the filter's values
    // if the array returned by intersection() has a length greater than zero, than it means there's a match
    const noMatch = filter.values.filter(value => {
        if (value === matchedItemFilterOptions) {
            return true;
        }

        let isMatch = false;

        const exploded = matchedItemFilterOptions.split(',');
        exploded.forEach(element => {
            if (element.trim() === value) {
                isMatch = true;
            }
        });

        return isMatch;
    });

    return noMatch.length >= 1 && true;
}
